import { supabase } from './supabase';

interface ContactFormData {
  fullName: string;
  email: string;
  phone: string;
  countryCode: string;
  message: string;
}

interface NewsletterData {
  fullName: string;
  email: string;
}

export const submitContactForm = async (data: ContactFormData) => {
  const { error } = await supabase
    .from('contacts')
    .insert({
      full_name: data.fullName,
      email: data.email,
      phone: data.phone,
      message: data.message,
      source: 'contact_form'
    });

  if (error) throw new Error('Failed to submit contact form');
  return { success: true };
};

export const subscribeNewsletter = async (data: NewsletterData) => {
  const { error } = await supabase
    .from('contacts')
    .insert({
      full_name: data.fullName,
      email: data.email,
      source: 'newsletter'
    });

  if (error) throw new Error('Failed to subscribe to newsletter');
  return { success: true };
};